export default __webpack_public_path__ + "static/media/restaurent-img.c26a27b2.png";